export default "__VITE_ASSET__FUU9zxEd__"